let logger = require("logger");
let environment = require("environment");
if (environment.default) {
  environment = environment.default;
}

const basepath = process.env.PUBLIC_URL + "/ui";
exports.home = basepath + "/home";
exports.login = basepath + "/login";
exports.homepage = basepath + "/homepage";
exports.admin = basepath + "/admin";
exports.accounts = basepath + "/accounts";
exports.accountdetail = basepath + "/accountdetail";
exports.taskhistory = basepath + "/taskhistory";
exports.wallremover = basepath + "/wallremover";
exports.runningtasks = basepath + "/runningtasks";
exports.runningtasksadmin = basepath + "/runningtasksadmin";

//http://13.211.219.124/SLInterActiveCampaignMiddleware/api/v1/history
//const scheme = "http://";
let scheme = environment.API_SCHEME;
let hostname = environment.API_URL;
let apibasepath = environment.API_CONTEXT;
logger.log(process.env, environment);
const apiUrl = scheme + hostname + apibasepath;
logger.log(apiUrl);
exports.hostname = hostname;
exports.apiUrl = apiUrl;
exports.loginApiPath = apiUrl + "/login";
exports.dotaskactionApiPath = apiUrl + "/dotaskaction";
exports.getaccountsApiPath = apiUrl + "/getaccounts";
exports.getaccountdetailsApiPath = apiUrl + "/getaccountdetails";
exports.addaccountApiPath = apiUrl + "/addaccount";
exports.removeaccountApiPath = apiUrl + "/removeaccount";
exports.addservertoaccountApiPath = apiUrl + "/addservertoaccount";
exports.getpublicdataApiPath = apiUrl + "/getpublicdata";
exports.downloadApiPath = apiUrl + "/download";


exports.showNewTable =  environment.SHOW_NEW_TABLE || false;
